import { createContext, useContext, useMemo } from 'react'

import { useContainerBreakpoints } from 'hooks/use_container_breakpoints'
import { useResizeObserver } from 'hooks/use_resize_observer'

import { SHELL_SIDE_PANEL_COMPACT_MAX_WIDTH_PX } from './constants'

const ShellSidePanelCompactContext = createContext(null)

/**
 * Measures `#shell-side-panel-content` width and exposes compact state to descendants
 * (matches `shellSidePanelCompact` container query).
 */
export const ShellSidePanelCompactProvider = ({ children }) => {
  const { ref, width } = useResizeObserver()
  const { isCompact } = useContainerBreakpoints(width, {
    isCompact: SHELL_SIDE_PANEL_COMPACT_MAX_WIDTH_PX,
  })

  const value = useMemo(() => ({ isCompact }), [isCompact])

  return (
    <ShellSidePanelCompactContext.Provider value={value}>
      {children(ref)}
    </ShellSidePanelCompactContext.Provider>
  )
}

/** False when rendered outside the app shell side panel. */
export function useShellSidePanelCompact() {
  const context = useContext(ShellSidePanelCompactContext)
  return context?.isCompact ?? false
}
